import PropTypes from 'prop-types';

export function deprecated(validator, message = '') {
  return function deprecated(props, propName, componentName, ...rest) {
    if (props[propName] != null) {
      // eslint-disable-next-line
      console.warn(`${componentName}::${propName} is deprecated. ${message}`);
    }
    return validator(props, propName, componentName, ...rest);
  };
}

export function childTypeValidator(Component, name) {
  return (propValue, key, componentName) =>
    propValue[key].type !== Component
      ? new Error(`${componentName} only accepts components of type ${name}.`)
      : null;
}

export function responsiveType(type) {
  return PropTypes.oneOfType([type, PropTypes.objectOf(type)]);
}
